// Derived from Blockscout frontend v2.3.0, licensed under GPL-3.0.
// MutualismDao branding changes: 2026-10-25. See /open-source.html for notices and source.
import { Box, Flex, Grid, Text } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import { Link } from 'toolkit/chakra/link';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';
import NetworkAddToWallet from 'ui/shared/NetworkAddToWallet';

import IntTxsIndexingStatus from './IntTxsIndexingStatus';

const Footer = () => {
  return (
    <Box as="footer" borderTopWidth="1px" borderTopColor="border.divider">
      <Grid
        px={{ base: 4, lg: config.UI.navigation.layout === 'horizontal' ? 6 : 12, '2xl': 6 }}
        py={{ base: 6, lg: 8 }}
        maxW={ `${ CONTENT_MAX_WIDTH }px` }
        m="0 auto"
        gap={{ base: 6, lg: 8 }}
        gridTemplateColumns={{ base: '1fr', lg: 'minmax(0, 1fr) auto' }}
      >
        <Box>
          <Link href="/" fontWeight={ 600 } fontSize="md">共生道 MTD</Link>
          <Text fontSize="sm" mt={ 1 }>MutualismDao</Text>
          <Text fontSize="xs" mt={ 3 }>查询共生道网络的区块、交易和地址。</Text>
          <Flex flexWrap="wrap" gap={ 5 } mt={ 4 } fontSize="sm">
            <Link href="/blocks">区块</Link>
            <Link href="/txs">交易</Link>
            <Link href="/api-docs">API 文档</Link>
            <Link href="/open-source.html">开源许可</Link>
          </Flex>
        </Box>
        <Flex flexDirection="column" gap={ 4 } alignItems={{ base: 'flex-start', lg: 'flex-end' }}>
          <NetworkAddToWallet/>
          { !config.UI.indexingAlert.intTxs.isHidden && <IntTxsIndexingStatus/> }
        </Flex>
        { config.services.reCaptchaV2.siteKey && (
          <Box fontSize="xs">
            <span>This site is protected by reCAPTCHA and the Google </span>
            <Link href="https://policies.google.com/privacy" external noIcon>Privacy Policy</Link>
            <span> and </span>
            <Link href="https://policies.google.com/terms" external noIcon>Terms of Service</Link>
            <span> apply.</span>
          </Box>
        ) }
      </Grid>
    </Box>
  );
};

export default React.memo(Footer);
